import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Axios from 'axios';
import BaseNavPage from './templates/components/BaseNavPage';
import NoProblem from './templates/NoProblem';
import Yahoo from './templates/Yahoo';
import Submitted from './templates/Submitted';
import EmailUsSubmitted from './templates/EmailUsSubmitted';
import HelpMain from './templates/HelpMain';
import LoginPage from './templates/LoginPage';
import Error from './templates/Error';

import HelpWithMyOrder from './templates/help_with_my_order/HelpWithMyOrder';
import HelpWithMyOrderNew from './templates/help_with_my_order/HelpWithMyOrderNew';
import HelpWithMyOrderMP from './templates/help_with_my_order/HelpWithMyOrderMP';
import HelpWithMyOrderEbook from './templates/help_with_my_order/HelpWithMyOrderEBook';
import HelpWithMyOrderRental from './templates/help_with_my_order/HelpWithMyOrderRental';
import HelpWithMyOrderUsed from './templates/help_with_my_order/HelpWithMyOrderUsed';

import ConfirmReturn from './templates/help_with_my_order/common/return/ConfirmReturn';
import ConfirmCancel from './templates/help_with_my_order/common/cancel/ConfirmCancel';
import CanceledSuccessfully from './templates/help_with_my_order/common/cancel/CanceledSuccessfully';
import WhereIsMyBook from './templates/help_with_my_order/common/WhereIsMyBook';
import WhenWillMyBookShip from './templates/help_with_my_order/common/where_is_my_book/WhenWillMyBookShip';
import MissingItem from './templates/help_with_my_order/common/where_is_my_book/MissingItem';
import TrackingSaysDelivered from './templates/help_with_my_order/common/where_is_my_book/TrackingSaysDelivered';
import TrackingSaysReturned from './templates/help_with_my_order/common/where_is_my_book/TrackingSaysReturned';
import TrackingStoppedMoving from './templates/help_with_my_order/common/where_is_my_book/TrackingStoppedMoving';
import GotWrongBook from './templates/help_with_my_order/common/GotWrongBook';
import WrongBookNeedOther from './templates/help_with_my_order/common/wrong_book/WrongBookNeedOther';
import WrongItemReceived from './templates/help_with_my_order/common/wrong_book/WrongItemReceived';
import RetailBookDamaged from './templates/help_with_my_order/retail/RetailBookDamaged';
import RentalBookDamaged from './templates/help_with_my_order/rental/RentalBookDamaged';
import MPBookDamaged from './templates/help_with_my_order/mp/MPBookDamaged';
import SellerNotResponding from './templates/help_with_my_order/mp/SellerNotResponding';
import NoRefundYet from './templates/help_with_my_order/retail/NoRefundYet';
import BundleMissesComponent from './templates/help_with_my_order/common/BundleMissesComponent';
import HowToRedeem from './templates/help_with_my_order/ebook/HowToRedeem';
import WantToExtendTerm from './templates/help_with_my_order/ebook/WantToExtendTerm';
import WrongEbook from './templates/help_with_my_order/ebook/WrongEbook';
import ExtendRental from './templates/help_with_my_order/rental/ExtendRental';

import GeneralQuestions from './templates/general_questions/GeneralQuestions';
import CourseDoesntHaveBook from './templates/general_questions/course_doesnt_have_book/CourseDoesntHaveBook';
import ThereIsBookGotIsbn from './templates/general_questions/course_doesnt_have_book/ThereIsBookGotIsbn';
import ThereIsBookGotTitle from './templates/general_questions/course_doesnt_have_book/ThereIsBookGotTitle';
import ThereIsBookGotNoIsbn from './templates/general_questions/course_doesnt_have_book/ThereIsBookGotNoIsbn';
import SupposedToBeBook from './templates/general_questions/course_doesnt_have_book/SupposedToBeBook';
import RedeemVoucher from './templates/general_questions/RedeemVoucher';
import HowToFindBook from './templates/general_questions/HowToFindBook';
import ErrorWhenPay from './templates/general_questions/ErrorWhenPay';
import FormsOfPayment from './templates/general_questions/FormsOfPayment';
import SupplementalMaterials from './templates/general_questions/SupplementalMaterials';
import WhyOptionsArentShowing from './templates/general_questions/WhyOptionsArentShowing';
import CantLogin from './templates/general_questions/CantLogin';
import CanShipToCampus from './templates/general_questions/CanShipToCampus';
import WhyChargedTax from './templates/general_questions/WhyChargedTax';
import MeantOtherPaymentMethod from './templates/general_questions/MeantOtherPaymentMethod';

import MySales from './templates/sales_questions/MySales';
import SalesQuestions from './templates/sales_questions/SalesQuestions';
import WhenWillReceivePayment from './templates/sales_questions/WhenWillReceivePayment';
import ManageLabel from './templates/sales_questions/ManageLabel';
import CanCancelSale from './templates/sales_questions/CanCancelSale';
import VacationHold from './templates/sales_questions/VacationHold';
import VolumeSellers from './templates/sales_questions/VolumeSellers';
import WhyOnHold from './templates/sales_questions/WhyOnHold';

import BuybackQuestions from "./templates/buyback_questions/BuybackQuestions";
import HowCanIGetPaidForBook from "./templates/buyback_questions/HowCanIGetPaidForBook";
import HowLongDoesItTakeForMeToGetPaid from "./templates/buyback_questions/HowLongDoesItTakeForMeToGetPaid";


Vue.prototype.$eventHub = new Vue();
Vue.prototype.$globs = {};
Vue.prototype.$globs.login_form = window['login_form'];
Vue.prototype.$globs.customer_info = window['init_json_data'] ? window['init_json_data']['customer_info'] : {};
Vue.prototype.$globs.institute_info = window['init_json_data'] ? window['init_json_data']['institute_info'] : {};
Vue.prototype.$globs.captcha_settings = window['init_json_data'] ? window['init_json_data']['captcha_settings'] : {};
Vue.prototype.$globs.return_url = window['return_url'];

Vue.prototype.$globs.isLoggedIn = function () {
	return !!Object.keys(Vue.prototype.$globs['customer_info']).length;
};

Vue.mixin({
	computed: {
		is_mobile(){
			return window.matchMedia("(min-width : 320px) and (max-width : 480px)").matches;
		}
	}
});

const router = new VueRouter({
	// mode: 'history',
	routes: [
		{
			name: 'Root',
			path: '/',
			component: HelpMain,
		},
		{
			name: 'LoginPage',
			path: '/auth',
			component: LoginPage,
			props: true,
		},
		{
			name: 'Error',
			path: '/error',
			component: Error,
			props: true,
		},
		{
			name: 'NoProblem',
			path: '/no_problem',
			component: NoProblem,
		},
		{
			name: 'Yahoo',
			path: '/that_worked',
			component: Yahoo,
		},
		{
			name: 'Submitted',
			path: '/submitted',
			component: Submitted,
		},
		{
			name: 'EmailUsSubmitted',
			path: '/cs_request_submitted',
			component: EmailUsSubmitted,
		},
		{
			name: 'HelpWithMyOrder',
			path: '/help_with_my_order',
			component: HelpWithMyOrder,
			meta: {
				requireAuth: true,
				byOrder: true,
				title: 'Please log in or enter your order info',
			},
		},
		{
			name: 'HelpWithMyOrder_New',
			path: '/help_with_my_order_item/new/:id',
			component: HelpWithMyOrderNew,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'HelpWithMyOrder_Used',
			path: '/help_with_my_order_item/used/:id',
			component: HelpWithMyOrderUsed,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'HelpWithMyOrder_MP',
			path: '/help_with_my_order_item/exchange/:id',
			component: HelpWithMyOrderMP,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'HelpWithMyOrder_Ebook',
			path: '/help_with_my_order_item/ebook/:id',
			component: HelpWithMyOrderEbook,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'HelpWithMyOrderRental',
			path: '/help_with_my_order_item/rental/:id',
			component: HelpWithMyOrderRental,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'ConfirmReturn',
			path: '/return/:id',
			component: ConfirmReturn,
		},
		{
			name: 'ConfirmCancel',
			path: '/cancel/:id',
			component: ConfirmCancel,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'CanceledSuccessfully',
			path: '/canceled_successfully',
			component: CanceledSuccessfully,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'WhereIsMyBook',
			path: '/where_is_my_book/:id',
			component: WhereIsMyBook,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'WhenWillMyBookShip',
			path: '/when_will_book_ship/:id',
			component: WhenWillMyBookShip,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'MissingItem',
			path: '/missing_item/:id',
			component: MissingItem,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'TrackingSaysDelivered',
			path: '/tracking_delivered/:id',
			component: TrackingSaysDelivered,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'TrackingSaysReturned',
			path: '/tracking_returned/:id',
			component: TrackingSaysReturned,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'TrackingStoppedMoving',
			path: '/tracking_stopped_moving/:id',
			component: TrackingStoppedMoving,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'GotWrongBook',
			path: '/got_wrong_book/:id',
			component: GotWrongBook,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'WrongBookNeedOther',
			path: '/need_other_book/:id',
			component: WrongBookNeedOther,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'WrongItemReceived',
			path: '/received_wrong_book/:id',
			component: WrongItemReceived,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'RetailBookDamaged',
			path: '/retail_book_damaged/:id',
			component: RetailBookDamaged,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'RentalBookDamaged',
			path: '/rental_book_damaged/:id',
			component: RentalBookDamaged,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'MPBookDamaged',
			path: '/mp_book_damaged/:id',
			component: MPBookDamaged,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'NoRefundYet',
			path: '/retail_no_refund_yet/:id',
			component: NoRefundYet,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'BundleMissesComponent',
			path: '/bundle_missing_component/:id',
			component: BundleMissesComponent,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'HowToRedeem',
			path: '/how_to_redeem/:id',
			component: HowToRedeem,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'WantToExtendTerm',
			path: '/want_to_extend_term/:id',
			component: WantToExtendTerm,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'WrongEbook',
			path: '/wrong_ebook/:id',
			component: WrongEbook,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'ExtendRental',
			path: '/extend_rental/:id',
			component: ExtendRental,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},

		// General Questions
		{
			name: 'GeneralQuestions',
			path: '/general_questions',
			component: GeneralQuestions,
		},
		{
			name: 'CourseDoesntHaveBook',
			path: '/course_doesnt_have_book',
			component: CourseDoesntHaveBook,
		},
		{
			name: 'ThereIsBookGotIsbn',
			path: '/there_is_book_got_isbn/:course_id',
			component: ThereIsBookGotIsbn,
		},
		{
			name: 'ThereIsBookGotTitle',
			path: '/there_is_book_got_title/:course_id',
			component: ThereIsBookGotTitle,
		},
		{
			name: 'ThereIsBookGotNoIsbn',
			path: '/there_is_book_got_no_isbn/:course_id',
			component: ThereIsBookGotNoIsbn,
		},
		{
			name: 'SupposedToBeBook',
			path: '/supposed_to_be_book/:course_id',
			component: SupposedToBeBook,
		},
		{
			name: 'RedeemVoucher',
			path: '/redeem_voucher',
			component: RedeemVoucher,
		},
		{
			name: 'HowToFindBook',
			path: '/how_to_find_book',
			component: HowToFindBook,
		},
		{
			name: 'ErrorWhenPay',
			path: '/error_when_pay',
			component: ErrorWhenPay,
		},
		{
			name: 'FormsOfPayment',
			path: '/forms_of_payment',
			component: FormsOfPayment,
		},
		{
			name: 'SupplementalMaterials',
			path: '/supplemental_materials',
			component: SupplementalMaterials,
		},
		{
			name: 'WhyOptionsArentShowing',
			path: '/why_options_arent_showing',
			component: WhyOptionsArentShowing,
		},
		{
			name: 'CantLogin',
			path: '/cant_log_in',
			component: CantLogin,
		},
		{
			name: 'CanShipToCampus',
			path: '/cant_ship_to_campus',
			component: CanShipToCampus,
		},
		{
			name: 'WhyChargedTax',
			path: '/why_charged_tax/:id',
			component: WhyChargedTax,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'MeantOtherPaymentMethod',
			path: '/meant_other_payment_method/:id',
			component: MeantOtherPaymentMethod,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},
		{
			name: 'SellerNotResponding',
			path: '/seller_isnt_responding/:id',
			component: SellerNotResponding,
			meta: {
				requireAuth: true,
				byOrder: true,
			},
		},

		// Sales Questions
		{
			name: 'MySales',
			path: '/my_sales',
			component: MySales,
			meta: {
				requireAuth: true,
				title: 'Please log in to see your inventory',
			},
		},
		{
			name: 'SalesQuestions',
			path: '/sales_questions/:item_id',
			component: SalesQuestions,
			meta: {
				requireAuth: true,
			},
		},
		{
			name: 'WhenWillReceivePayment',
			path: '/when_will_i_receive_payment/:item_id',
			component: WhenWillReceivePayment,
			meta: {
				requireAuth: true,
			},
		},
		{
			name: 'ManageLabel',
			path: '/manage_label/:item_id',
			component: ManageLabel,
			meta: {
				requireAuth: true,
			},
		},
		{
			name: 'CanCancelSale',
			path: '/can_cancel_sale/:item_id',
			component: CanCancelSale,
			meta: {
				requireAuth: true,
			},
		},
		{
			name: 'VacationHold',
			path: '/vacation/:item_id',
			component: VacationHold,
			meta: {
				requireAuth: true,
			},
		},
		{
			name: 'VolumeSellers',
			path: '/volume_sellers/:item_id',
			component: VolumeSellers,
			meta: {
				requireAuth: true,
			},
		},
		{
			name: 'WhyOnHold',
			path: '/why_on_hold/:item_id',
			component: WhyOnHold,
			meta: {
				requireAuth: true,
			},
		},

		// Buyback Questions
		{
			name: 'BuybackQuestions',
			path: '/buyback_questions',
			component: BuybackQuestions,
		},
		{
			name: 'HowCanIGetPaidForBook',
			path: '/how_i_can_get_paid_for_book',
			component: HowCanIGetPaidForBook,
		},
		{
			name: 'HowLongDoesItTakeForMeToGetPaid',
			path: '/how_long_does_it_take_for_me_to_get_paid',
			component: HowLongDoesItTakeForMeToGetPaid,
		},
	]
});

router.beforeEach((to, from, next) => {
	if (to.meta.requireAuth && !Vue.prototype.$globs.isLoggedIn()) {
		next({
			name: 'LoginPage',
			params: Object.assign({returnUrl: '/help#' + to.path}, to.meta),
		});
	} else if (to.name === 'LoginPage' && Vue.prototype.$globs.isLoggedIn()) {
		next({
			path: '/',
			replace: true,
		});
	} else if (to.params.id || to.params.item_id) {
		var preload = window.setTimeout(() => {Vue.prototype.$eventHub.$emit('show-loader')}, 2000);
		Axios.get('/service/customer_help/rest/index.php/customer_help/check_order_belongs_customer/' +
			(parseInt(to.params.id || to.params.item_id) || 0) + '/' + (to.params.id ? 'order' : 'sale')
		).then(response => {
			if (response.data === false) {
				next({
					name: 'Error',
					replace: true,
					params: {
						title: 'Invalid Order',
						message: null,
					},
				});
			} else {
				next();
			}
		}).finally(() => {
			clearTimeout(preload);
			Vue.prototype.$eventHub.$emit('hide-loader');
		});
	} else {
		next();
	}
});

Vue.use(Vuetify);
Vue.use(VueRouter);

const app = new Vue({
		el: '#contacts-wrapper',

		router,

		components: {
			'v-base-nav-page': BaseNavPage
		},

		data() {
			return {
				loading: false,
				alert: false,
				title: 'Oops',
				message: 'Something went wrong, please try again.',
			};
		},

		mounted() {
			this.init();
		},

		computed: {},

		methods: {
			init() {
				let self = this;

				self.$eventHub.$on('show-loader', function () {
					self.loading = true;
				});

				self.$eventHub.$on('hide-loader', function () {
					self.loading = false;
				});

				this.$eventHub.$on('alert', (message, title) => {
					this.title = title || this.title;
					this.message = message || this.message;
					this.alert = true;
				});

				const adaFocus = function () {
					window.setTimeout(function () {
						const ada = document.querySelector(".ada-focus");
						if (ada) {
							ada.style.display = 'block';
							ada.focus();
						}
					}, 0);
				};

				adaFocus();

				router.afterEach((to, from, next) => {
					adaFocus();
					sendFBPixelAction(`FAQ: ${to.name}`, to.params, true);
					if (window.gtag) {
						const route_params = _.toPairs(to.params);
						let gtag_params = {
							event_category: 'FAQ',
							event_label: to.name,
							user_properties: window.ga_user_properties
						};
						if (route_params.length) {
							const param = route_params.pop();
							gtag_params[param[0]] = parseInt(param[1]);
						}
						gtag('event', to.name, gtag_params);
					}
				})
			},
		},

		watch: {
			title: function(value) {
				this.title = value.trim().replace(/\.+$/, '');
			},
		},
	})
;
